import { render, staticRenderFns } from "./RaBaseView.vue?vue&type=template&id=3502da24&scoped=true"
import script from "./RaBaseView.vue?vue&type=script&lang=js"
export * from "./RaBaseView.vue?vue&type=script&lang=js"
import style0 from "./RaBaseView.vue?vue&type=style&index=0&id=3502da24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3502da24",
  null
  
)

export default component.exports